import { FormHelperText, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '4px 14px 0px 14px',
    width: '100%', 
    flexShrink: 0,
  }
}))


export const ErrorHelpText = props => {

  const classes = useStyles();

  if (!props.error) {
    return '';
  }

  return (
    <FormHelperText className={classes.root} error={true} id={`${props.id}-error`}>
      {props.error}
    </FormHelperText>
  ) 
}